import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  usuarioid: 0,
  empresaid: 0,
  banco: 'setabd',
  user: {},
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setUsuarioID: (state, action) => {
      // console.log("store.login - setUsuarioID: ", action.payload);
      state.usuarioid = action.payload;
      // if (state.user) state.user.PESSOAID = action.payload;
    },

    setEmpresaID: (state, action) => {
      // console.log("store.login - setEmpresaID: ", action.payload);
      state.empresaid = action?.payload?.EMPRESAID || action.payload;
      // if (state.user) state.user.EMPRESAID = action.payload;
    },

    setUser: (state, action) => {
      // console.log("store.login - setUser: ", action.payload);
      state.user = action.payload;
      state.usuarioid =
        state.usuarioid || state.user.PESSOAID || state.user.USUARIOID;
      // state.empresaid = state.empresaid || state.user.EMPRESAID;
    },
    setBanco: (state, action) => {
      console.log("store.login - setBanco: ", state.banco);
      state.banco = action?.payload?.banco || action?.payload?.BANCO || action.payload;
    },

    restart: (state) => {
      // console.log("store.login - restart");
      state.empresaid = 0;
      state.usuarioid = 0;
      state.user = {};
      // state.banco = 'setabd';
    },
  },
});

export const { setUsuarioID, setEmpresaID, setUser, setBanco, restart } =
  loginSlice.actions;

export default loginSlice.reducer;
